import React, { Component, PropTypes } from 'react';
import { TextField } from 'material-ui';
import UUID from 'node-uuid';

class TypeControlledTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: '',
    };
  }

  _handleErrors = (errorText, cb) => {
    this.setState({ errorText }, () => {
      if (cb) return cb();
      if (this.props.onError) this.props.onError(errorText);
    });
  };

  _handleOnChange = (e) => {
    if (e.target.value && this.props.controlledType === 'number' && isNaN(e.target.value)) {
      this._handleErrors(`Only ${this.props.controlledType}s allowed`, () => this.props.onChange({ target: { value: undefined } }));
    } else if (this.props.limitLength && e.target.value && e.target.value.length > this.props.limitLength) {
      this._handleErrors(`Maximum ${this.props.limitLength} characters allowed`);
    } else {
      this.props.onChange(e);
      this._handleErrors('');
    }
  };

  _handleOnBlur = e => {
    this.setState({ errorText: '' });
  };

  render() {
    const { controlledType, onChange, limitLength, errorText, value, id, ...extraProps } = this.props;
    return (<TextField
      id={id || 'type-controlled-textfield'}
      errorText={errorText || this.state.errorText}
      onChange={this._handleOnChange}
      onBlur={this._handleOnBlur}
      value={value || ''}
      {...extraProps}
    />);
  }
}

TypeControlledTextField.propTypes = {
  controlledType: PropTypes.string,
  errorText: PropTypes.string,
  limitLength: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onError: PropTypes.func,
};

export default TypeControlledTextField;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/type-controlled-textfield.jsx